import { useQuery } from '@tanstack/react-query';

import { payCalendarsService, FetchPayCalendarsResponse } from '@aslanpay/portal-common-lib';

import { ASSIGNABLE_PAY_CALENDAR_STATUSES } from 'app/utils/payCalendars';

const useFetchPayCalendarsForEmployee = (companyId: string[]) => {
  return useQuery<FetchPayCalendarsResponse, Error>(
    ['fetchPayCalendarsForEmployee', companyId],
    () =>
      payCalendarsService.fetchPayCalendars({
        companyId,
        status: ASSIGNABLE_PAY_CALENDAR_STATUSES,
        page: 0,
        size: 999999,
      }),
    {
      enabled: companyId.length > 0 && companyId[0] !== '',
    }
  );
};

export default useFetchPayCalendarsForEmployee;
